export default __webpack_public_path__ + "static/media/letter.86b48b00.svg";